import { Component, input, output } from "@angular/core";

@Component({
  selector: "app-search-input",
  templateUrl: "./search-input.component.html",
})
export class SearchInputComponent {
  placeholder = input<string>("Search");
  value = input<string>("");
  flat = input<boolean>(false);
  /** Opt-in: no border/shadow, background matches the surrounding page, large corner radius. */
  pageBg = input<boolean>(false);
  /** Opt-in: DS 2.1 neumorphic look — sunken background, no border, icon trailing in its own box. */
  sunken = input<boolean>(false);
  /** Opt-in (with sunken): magnifier on the left, like the DS 2.1 home search. */
  iconLeading = input<boolean>(false);
  /** Opt-in: shows a clear (x) button while there is text. */
  clearable = input<boolean>(false);
  valueChange = output<string>();

  onInputChange(newValue: string): void {
    this.valueChange.emit(newValue);
  }
}
